// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___oR9GG","active":"active___K-Ldh","time":"time___3Ifui","who":"who___3BySa","message":"message___2EoRC","unread":"unread___1sItQ","photo":"photo___1GfOT"};